import type { SupportedLanguageCode } from '@bomdisoft/translations';
import type { MetadataRoute } from 'next';

export const SEO_LOCALES: SupportedLanguageCode[] = ['en', 'fr', 'et', 'ru', 'de', 'es', 'pt', 'ar', 'sw', 'hi', 'id', 'fil', 'vi', 'zh', 'ko', 'ja', 'bn', 'am'];

export const DEFAULT_LOCALE: SupportedLanguageCode = 'en';

export type SeoRoute = {
  changeFrequency: NonNullable<MetadataRoute.Sitemap[number]['changeFrequency']>;
  path: string;
  priority: number;
};

export type ProductSeoConfig = {
  brandName: string;
  locales: SupportedLanguageCode[];
  productionHost: string;
  routes: SeoRoute[];
};

export const toCanonicalPath = (locale: SupportedLanguageCode, path: string): string => {
  const trimmed = path.replace(/^\/+|\/+$/g, '');
  return trimmed ? `/${locale}/${trimmed}` : `/${locale}`;
};

export const toAbsoluteUrl = (host: string, locale: SupportedLanguageCode, path: string): string => `https://${host}${toCanonicalPath(locale, path)}`;
